import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'

import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'

/* This will show if decisions?.length > 0 && hasSelectedDecision && compliance is still in review */
const OfferAcceptedBanner = () => {
  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Success}
        subtext={
          <FormattedMessage
            defaultMessage='We’ll verify your identity and get in touch about next steps within 3-5 days.'
            id='sputnik.OfferAcceptedBanner__dezVS5'
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Offer accepted'
            id='sputnik.OfferAcceptedBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default OfferAcceptedBanner
